import { PawPrint, Share2 } from "lucide-react";
import shareCardBg from "@/assets/share-card-bg.png";

interface Props {
  backgroundDataUrl?: string;
}

/**
 * Story 12: "Udostępnianie = pomoc" - czytelny, konkretny, z checklist vibe
 */
export const InstagramStoryShare12 = ({ backgroundDataUrl }: Props) => {
  const bgImage = backgroundDataUrl || shareCardBg;

  return (
    <div
      style={{
        width: "1080px",
        height: "1920px",
        fontFamily: "'Nunito', sans-serif",
        display: "flex",
        flexDirection: "column",
        position: "relative",
        overflow: "hidden",
        backgroundColor: "#1a3a2a",
      }}
    >
      <img
        src={bgImage}
        alt=""
        draggable={false}
        data-export-bg="true"
        loading="eager"
        decoding="sync"
        style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", objectFit: "cover", zIndex: 0 }}
      />
      <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: "8px", background: "linear-gradient(90deg, #4E8A6E 0%, #6BAF8D 50%, #4E8A6E 100%)", zIndex: 2 }} />

      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: "200px 80px",
          position: "relative",
          zIndex: 1,
        }}
      >
        {/* Share icon */}
        <div
          style={{
            background: "rgba(78, 138, 110, 0.15)",
            borderRadius: "50%",
            width: "130px",
            height: "130px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: "48px",
          }}
        >
          <Share2 style={{ width: "60px", height: "60px", color: "#4E8A6E" }} />
        </div>

        {/* Headline */}
        <h1
          style={{
            fontSize: "72px",
            fontWeight: 800,
            color: "#2D5A3D",
            margin: "0 0 16px",
            textAlign: "center",
            lineHeight: 1.2,
          }}
        >
          Jak pomóc
          <br />
          w 10 sekund?
        </h1>

        {/* Divider */}
        <div style={{ width: "100px", height: "6px", background: "#4E8A6E", borderRadius: "3px", margin: "32px 0 40px" }} />

        {/* Checklist */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "20px",
            marginBottom: "56px",
            width: "100%",
            maxWidth: "820px",
          }}
        >
          {[
            { check: "✅", text: "Wejdź na gdzieschronisko.pl" },
            { check: "✅", text: "Znajdź schronisko w okolicy" },
            { check: "✅", text: "Wyślij link 3 znajomym" },
          ].map((item, i) => (
            <div
              key={i}
              style={{
                background: "rgba(255,255,255,0.95)",
                borderRadius: "20px",
                padding: "28px 40px",
                boxShadow: "0 4px 16px rgba(0,0,0,0.06)",
                display: "flex",
                alignItems: "center",
                gap: "24px",
              }}
            >
              <span style={{ fontSize: "40px" }}>{item.check}</span>
              <p style={{ fontSize: "34px", fontWeight: 700, color: "#2D5A3D", margin: 0 }}>
                {item.text}
              </p>
            </div>
          ))}
        </div>

        {/* Bottom message */}
        <p
          style={{
            fontSize: "44px",
            fontWeight: 700,
            color: "#3D6B52",
            margin: "0 0 48px",
            textAlign: "center",
            lineHeight: 1.4,
          }}
        >
          Tyle wystarczy,
          <br />
          żeby pomagać 💚
        </p>

        {/* CTA */}
        <div
          style={{
            background: "#4E8A6E",
            borderRadius: "50px",
            padding: "24px 56px",
          }}
        >
          <p style={{ fontSize: "36px", fontWeight: 700, color: "#FFFFFF", margin: 0 }}>
            Udostępnij dalej
          </p>
        </div>
      </div>

      <div style={{ padding: "0 80px 100px", display: "flex", justifyContent: "center", position: "relative", zIndex: 1 }}>
        <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
          <div style={{ background: "#4E8A6E", borderRadius: "14px", width: "52px", height: "52px", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <PawPrint style={{ width: "28px", height: "28px", color: "#FFFFFF" }} />
          </div>
          <span style={{ fontSize: "28px", fontWeight: 700, color: "#2D5A3D" }}>gdzieschronisko.pl</span>
        </div>
      </div>
    </div>
  );
};
